import classNames from 'classnames'
import React from 'react'

/**
 * Chat-bubble chrome for a paid text-only message/preview. Deliberately
 * doesn't lean on `.str-chat`'s CSS variables (`--str-chat__message-bubble-*`)
 * — this renders in the Composer preview too, which sits outside any
 * `.str-chat` ancestor, so every value here (radius, colour, type scale) is
 * hardcoded to match the Figma spec directly.
 */
const TextShell: React.FC<
  React.PropsWithChildren<{ isMine: boolean; className?: string }>
> = ({ isMine, children, className }) => (
  <div
    className={classNames(
      'message-locked-attachment-text',
      'relative flex min-w-[225px] max-w-[280px] flex-col gap-1 rounded-[1.5rem] px-4 py-3',
      'text-[0.875rem] leading-[1.3125rem] tracking-[0.14px]',
      isMine ? 'bg-[#1e2330] text-white' : 'bg-[#f2f1ef] text-black',
      'shadow-[0_1px_2px_rgba(0,0,0,0.08)]',
      className
    )}
  >
    {children}
  </div>
)

export default TextShell
